module.exports = __webpack_public_path__ + "img/116ne.82f6bbc1.svg";